export default __webpack_public_path__ + "static/media/contactless.a127b729.svg";